var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarningOutlinedFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83984 1.39453C9.65334 0.162757 11.4924 0.201772 12.2354 1.51855H12.2344L19.7314 14.7686L19.7979 14.8955C20.4314 16.2125 19.5003 17.8085 18 17.8086H3.00195C1.44536 17.8083 0.512815 16.1034 1.26758 14.7695L8.76465 1.51855V1.51758L8.83984 1.39453Z",
    fill: "#FFD31F",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9282 6H9.81876C9.71251 6 9.62813 6.08919 9.63126 6.19749L9.86564 12.4407C9.86877 12.5458 9.95315 12.6255 10.0531 12.6255H10.6938C10.7938 12.6255 10.8782 12.5427 10.8813 12.4407L11.1157 6.19749C11.1188 6.08919 11.0344 6 10.9282 6ZM9.5 14.1544C9.5 13.6607 9.89064 13.2625 10.375 13.2625C10.8594 13.2625 11.2501 13.6607 11.2501 14.1544C11.2501 14.6481 10.8594 15.0463 10.375 15.0463C9.89064 15.0463 9.5 14.6481 9.5 14.1544Z",
    fill: "#1C1C1C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarningOutlinedFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/WarningOutlinedFilled.256d15ddf1aacf611e830c0f3a691f4c.svg";